export default "__VITE_ASSET__9241cc8d__"